import {css} from 'lit';
export const styles = css`:host {
  --chart-height: 200px;
  --bucket-gap: 8px;
  --grid-color: var(--gray-200, #e9ecef);
}

/* Two columns: the value axis, sized to its widest label, and the plot.
   Grid and body share the plot cell, so the data sits over the gridlines. */
.plot {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: var(--chart-height) auto;
  margin-top: 8px;
  -moz-column-gap: 8px;
       column-gap: 8px;
}

.axis {
  position: relative;
  grid-area: 1 / 1;
  width: 100%;
}

.gauge {
  visibility: hidden;
}

.gauge,
.mark {
  color: var(--heading-color);
  font-size: 0.6875rem;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.mark {
  position: absolute;
  right: 0;
  transform: translateY(50%);
}

.grid {
  position: relative;
  grid-area: 1 / 2;
}

.line {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--grid-color);
}

.body {
  position: relative;
  grid-area: 1 / 2;
}

.labels {
  display: flex;
  gap: var(--bucket-gap);
  grid-area: 2 / 2;
  padding-top: 8px;
  font-size: 0.6875rem;

  /* Spilling text is out of flow, so the row carries the height itself. */
  min-height: calc(8px + 1.2em);

  /* Bounds the spill: a label may cross its neighbours, never the plot. */
  overflow: hidden;
}

.label {
  flex: 1 1 0;
  min-width: 0;
  color: var(--heading-color);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Thinned labels have blank columns either side and need them: a date does not
   fit one bucket's width. \`text-align\` cannot place text that overflows its box,
   so the inner span is shifted instead. */
.spilling {
  position: relative;
  overflow: visible;
}

.spilling .text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.spilling.start .text {
  left: 0;
  transform: none;
}

.spilling.end .text {
  left: auto;
  right: 0;
  transform: none;
}
`;
export default styles;
